"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../theme.js"),t=require("../Skeleton.js"),r=e.styled(t.SkeletonBaseStyle,{height:"$xxsmall",width:"$xxlarge",borderRadius:"$pill"});exports.ChipSkeleton=r;
